import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {pluralize} from 'BenchlingUtil';
import {FONT_WEIGHT_PROXIMA_REGULAR} from 'styles/FontConstants';
import Tooltip from 'ui-library/bs/Tooltip';
import {GRAY_DARKER} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import Modal from 'ui-library/modals/Modal';

interface BulkEditModalProps {
  onRequestClose: () => void;
  collectionName: string;
  featureNames: Array<string>;
  onClickSave: () => void;
  children: JSX.Element;
}

/**
 * Modal wrapper for the form to bulk edit sequence features from the expanded tabs
 */
function BulkEditModal({
  onRequestClose,
  collectionName,
  featureNames,
  onClickSave,
  children,
}: BulkEditModalProps): JSX.Element {
  return (
    <Modal
      title={
        <div className={css(styles.titleContainer)}>
          <span className={css(styles.titleText)}>{`Bulk edit ${collectionName}s`}</span>
          <Tooltip title="Other fields cannot be edited in bulk for data integrity purposes.">
            <BenchlingIcon className={css(styles.titleIcon)} icon="info-circle" />
          </Tooltip>
        </div>
      }
      wrapInForm={false}
      onRequestClose={onRequestClose}
      buttons={[
        {
          text: 'Cancel',
          cancel: true,
        },
        {
          text: 'Save',
          submit: true,
          onClick: onClickSave,
        },
      ]}
    >
      <p
        className={css(styles.bodyText)}
      >{`Changes to field values apply to all selected ${collectionName}s.`}</p>
      <p>
        {`You are editing ${featureNames.length} ${pluralize(
          featureNames.length,
          collectionName
        )}: ${featureNames.join(', ')}.`}
      </p>
      <div className={css(styles.modalContentContainer)}>{children}</div>
    </Modal>
  );
}

const styles = StyleSheet.create({
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  titleText: {
    marginRight: '8px',
    fontWeight: FONT_WEIGHT_PROXIMA_REGULAR,
  },
  titleIcon: {
    color: GRAY_DARKER,
    width: '14px',
    height: '14px',
  },
  modalContentContainer: {
    marginTop: '16px',
  },
  bodyText: {
    marginBottom: '16px',
  },
});

export default BulkEditModal;
